module.exports = __webpack_public_path__ + "static/this-is-new-jira-acafac14896f10ee5d1fd96b5ccec6e7.png";